import {
  HTTP_CREATESPECIAL_FETCHING,
  HTTP_CREATESPECIAL_SUCCESS,
  HTTP_CREATESPECIAL_FAILED,
} from "./../../Constants";

const initialState = {
  result: null,
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_CREATESPECIAL_FETCHING:
      return { ...state, result: null, isLoading: true, isError: false };
    case HTTP_CREATESPECIAL_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_CREATESPECIAL_FAILED:
      return { ...state, result: null, isLoading: false, isError: true };
    default:
      return state;
  }
};
